import { render, staticRenderFns } from "./CaseReport.vue?vue&type=template&id=1a2779ce&"
import script from "./CaseReport.vue?vue&type=script&lang=js&"
export * from "./CaseReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports